import { FunctionComponent, useEffect, useRef, useState } from 'react'; //, createElement
import { getSmartworksMRCSSOURL } from 'Foundation/Configurations/GlobalConfiguration';
import { Link } from '@lmig/lmds-react-link';

const MarketingResourceCenter: FunctionComponent = () => {
  let formRef = useRef<HTMLFormElement>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [encryptedData, setEncryptedData] = useState<string | null>(null);
  const [userFound, setUserFound] = useState<boolean>(false);
  const [userID, setUserID] = useState<string | null>(null);

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlActionUrlParam = urlSearchParams.get('actionurl');
  const redirectMessage = urlSearchParams.get('redirectmessage') ?? 'Redirecting you to the Marketing Resource Center';

  const smartworksMRCSSOURL = getSmartworksMRCSSOURL(true); // https://login6.smartworks.com
  const smartworksAutoLoginUrl = smartworksMRCSSOURL + '/smwx/account/autologon';
  const smartworksIssuerRefNum = '260';

  const aisgEmail = 'AgencyInterfaceSupport@LibertyMutual.com';

  const getEncryptedData = async () => {
    try {
      if (!isLoaded) {
        const response = await fetch(`/api/sitecore/MRCSSOAsync/GetMRCSSO`, {
          method: 'GET',
        });
        let result = await response.json();
        let mrcSSOData: IMRCSSOData = result;

        setIsLoaded(true);

        if (mrcSSOData) {
          console.log('smartworks userFoundInUserDetails: ' + mrcSSOData.userFoundInUserDetails);
          console.log('smartworks encryptedPayload: ' + mrcSSOData.encryptedPayload);
          console.log('smartworks userId: ' + mrcSSOData.userId);
          console.log('smartworks smartWorksExternalLoginName: ' + mrcSSOData.smartWorksExternalLoginName);
          console.log('smartworks smartWorksRole: ' + mrcSSOData.smartWorksRole);

          if (mrcSSOData.encryptedPayload !== null) {
            setEncryptedData(mrcSSOData.encryptedPayload);
            if (mrcSSOData.userFoundInUserDetails !== null) {
              setUserFound(mrcSSOData.userFoundInUserDetails);
            }
          } else if (mrcSSOData.userId !== null) {
            setUserID(mrcSSOData.userId);
          }
        }
      }
    } catch (err: any) {
      console.error(`${'MRC SSO GetEncryptedData() Error'}() >> ${err.message}`);
    }
  };

  useEffect(() => {
    document.body.classList.add('force-show-body');
    if (!isLoaded) {
      getEncryptedData();
    }
  }, []);

  useEffect(() => {
    if (encryptedData) {
      submitForm();
    }
  }, [encryptedData]);

  const submitForm = () => {
    formRef?.current ? formRef.current.submit() : <></>;
  };

  return (
    <>
      <div className="smartworks-redirect-message">
        {!isLoaded ? (
          <div>{redirectMessage}</div>
        ) : userFound ? (
          <></>
        ) : (
          <>
            <div>
              {`We couldn't find a smartworks ID associated with your username
                      ${userID !== null ? ` ${userID}` : ''}
                      . Please contact our Agency Interface Support Group (AISG): `}
              <Link href={`mailto:${aisgEmail}`} variant="standalone" caretPosition="none">
                {aisgEmail}
              </Link>
            </div>
          </>
        )}
      </div>

      <form style={{ display: 'none' }} target="_self" method="POST" action={smartworksAutoLoginUrl} ref={formRef}>
        <input type="hidden" name="issuer" value={smartworksIssuerRefNum}></input>
        <input
          // for deeplinking
          type="hidden"
          name="actionurl"
          value={urlActionUrlParam !== null ? smartworksMRCSSOURL + urlActionUrlParam : ''}
        ></input>
        <input type="hidden" name="request" value={encryptedData ? encryptedData : ''}></input>
        <button type="submit">submit</button>
      </form>
    </>
  );
};

export default MarketingResourceCenter;
